<template>
  <div>
    <p>Choix du niveau de difficulté :</p>

    <button @click="chooseDifficulty(1)" class="bouton2">Facile</button>
    <button @click="chooseDifficulty(2)" class="bouton2">Moyen</button>
    <button @click="chooseDifficulty(3)" class="bouton2">Difficile</button>
  </div>
</template>

<script>
export default {
  name: "chooseDifficulty",
  data() {
    return {
      difficulty: 0,
    };
  },
  methods: {
    chooseDifficulty(difficulty) {
      switch (difficulty) {
        case 1:
          this.$store.commit("changeLife", 5);
          this.$store.commit("chooseDifficulty", 1);

          break;
        case 2:
          this.$store.commit("changeLife", 3);
          this.$store.commit("chooseDifficulty", 2);
          break;
        case 3:
          this.$store.commit("changeLife", 1);
          this.$store.commit("chooseDifficulty", 3);
          break;
      }
      this.$store.commit("activePage", "family");
    },
  },
};
</script>
